<template>
  <div class="home-container">
    <div class="home-main">
      <div class="main-header">
        <div class="logo-container">
          <img src="@/assets/image/home-logo.png" alt=""/>
          <div class="title">
            <span>为改变</span>
          </div>
        </div>
        <div class="menu-btn-container">
          <div class="language-btn">
            <span>简体中文</span>
          </div>
          <div class="menu-btn" @click="openMenu">
            <img src="@/assets/image/icon-menu.png" alt=""/>
          </div>
        </div>
      </div>
      <div class="main-body">
        <div class="body-content">
          <div class="main-content home-title-show">
            做<span style="color: #0057ff">改变</span>的创造者、推动者
          </div>
          <div class="sub-content home-title-show">
            <span
            >辰戈以用户为中心，改善体验，改变思维。加速解决方案的开发，提升企业在互联网数字化经济中的综合竞争力</span
            >
          </div>
        </div>
        <!-- 圆环容器 -->
        <div class="ring-container">
          <transition name="fade">
            <img :src="backgroundLogoUrl[showIndex]" alt="" v-show="ringShow"/>
          </transition>
        </div>

        <!-- 导航块容器 -->
        <div class="nav-cards-container">
          <div
            class="nav-card-container home-show"
            v-for="item in navCardData"
            :key="item.id"
            @click="navTo(item.id)"
            @mouseenter="mouseenter(item.id)"
            @mouseleave="mouseleave"
          >
            <div class="nav-card">
              <div class="name">
                <span>{{ item.name }}</span
                ><span>{{ item.English }}</span>
              </div>
              <div class="logo">
                <img :src="item.logoUrl" alt=""/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 首页-案例展示 -->
    <div class="home-case">
      <div class="title home-title-show">
        <span>案例展示</span>
        <span>为客户打造极具价值的产品</span>
      </div>
      <div class="case-exhibition">
        <div
          class="case-exhibition-card"
          v-for="item in caseData"
          :key="item.id"
          @click="toCaseDetail(item.id)"
        >
          <img :src="item.imgUrl" alt=""/>
          <div class="card-content-cell">
            <div class="card-cell-name">
              {{ item.name }}
            </div>
            <div class="card-cell-title">
              {{ item.title }}
            </div>
            <div class="span-cell">
              <div class="cell-value" v-for="itemValue in item.span">{{ itemValue }}</div>
            </div>
          </div>
        </div>
      </div>
      <!--      <div class="case-exhibition" style="margin-top: 30px">-->
      <!--        <img-->
      <!--          src="@/assets/image/kapipo.png"-->
      <!--          alt=""-->
      <!--          @click="toCaseDetail(4)"-->
      <!--          class="home-case-img-show"-->
      <!--        />-->
      <!--        <img-->
      <!--          src="@/assets/image/lgny.png"-->
      <!--          alt=""-->
      <!--          @click="toCaseDetail(5)"-->
      <!--          class="home-case-img-show"-->
      <!--        />-->
      <!--        <img-->
      <!--          src="@/assets/image/zncrm.png"-->
      <!--          alt=""-->
      <!--          @click="toCaseDetail(6)"-->
      <!--          class="home-case-img-show"-->
      <!--        />-->
      <!--      </div>-->
      <div class=" home-enter">
        <div class="all-case-btn" @click="navTo(1)">
          <span>查看全部案例</span>
        </div>
      </div>
    </div>
    <!-- 首页-服务内容 -->
    <div class="home-grey-box">
      <div class="home-service">
        <div class="title home-enter">
          <span>服务内容</span>
          <span>我们提供专业的一站式服务体系</span>
        </div>
        <div class="service-content-card-container">
          <div class="service-content-card home-enter">
            <div class="logo">
              <img src="@/assets/image/icon-strategy.png" alt=""/>
            </div>
            <div class="name"><span>产品策略</span></div>
            <div class="content">
              <ul>
                <li>需求分析</li>
                <li>用户研究</li>
                <li>体验创新</li>
                <li>策略完善</li>
              </ul>
            </div>
          </div>
          <div class="service-content-card home-enter">
            <div class="logo">
              <img src="@/assets/image/icon-design.png" alt=""/>
            </div>
            <div class="name"><span>产品设计</span></div>
            <div class="content">
              <ul>
                <li>思维导图</li>
                <li>低保真原型</li>
                <li>流程体验</li>
              </ul>
            </div>
          </div>
          <div class="service-content-card home-enter">
            <div class="logo">
              <img src="@/assets/image/icon-vision.png" alt=""/>
            </div>
            <div class="name"><span>视觉设计</span></div>
            <div class="content">
              <ul>
                <li>移动页面</li>
                <li>网页设计</li>
                <li>桌面应用</li>
              </ul>
            </div>
          </div>
          <div class="service-content-card home-enter">
            <div class="logo">
              <img src="@/assets/image/icon-brand.png" alt=""/>
            </div>
            <div class="name"><span>品牌设计</span></div>
            <div class="content">
              <ul>
                <li>企业VI系统</li>
                <li>标志设计</li>
                <li>平面设计</li>
              </ul>
            </div>
          </div>
          <div class="service-content-card home-enter">
            <div class="logo">
              <img src="@/assets/image/icon-develop.png" alt=""/>
            </div>
            <div class="name"><span>产品开发</span></div>
            <div class="content">
              <ul>
                <li>小程序开发</li>
                <li>中后台开发</li>
                <li>APP开发</li>
                <li>网站开发</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="all-case-btn-container home-enter">
          <div class="all-case-btn" @click="navTo(3)">
            <span>了解全部服务</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 首页-解决方案展示 -->
    <div class="home-resolution">
      <div class="title home-title-show">
        <span>解决方案</span>
        <span>用成熟的解决方案创造商业价值的裂变</span>
      </div>
      <div class="resolution-exhibition">
        <div
          class="resolution-exhibition-card"
          v-for="item in resolutionData"
          :key="item.id"
        >
          <div class="card-content-cell">
            <div class="card-cell-name">
              {{ item.name }}
            </div>
            <div class="card-cell-title">
              {{ item.title }}
            </div>
            <div class="span-cell">
              <div class="cell-value" v-for="itemValue in item.span">{{ itemValue }}</div>
            </div>
          </div>
          <img :src="item.imgUrl" alt=""/>
        </div>
      </div>
      <div class="home-enter">
        <div class="all-case-btn" @click="navTo(2)">
          <span>了解解决方案</span>
        </div>
      </div>
    </div>
    <!-- 首页-合作伙伴 -->
    <div class="home-grey-box">
      <div class="home-cooperative">
        <div class="title home-enter">
          <span>合作伙伴</span>
          <span>和各行业品牌伙伴一起成长</span>
        </div>
        <div class="cooperative-contents-container home-enter">
          <div
            class="cooperative-content"
            v-for="item in cooperativeData"
            :key="item.id"
          >
            <img :src="item.src" alt=""/>
          </div>
        </div>
      </div>
    </div>
    <!-- 首页-联系我们区域 -->
    <div class="home-contact home-enter">
      <div class="contact-content">
        <div class="main">
          告诉我们您的需求，<span style="color: #0057ff">改变</span>即刻开始
        </div>
        <div class="sub">
          <span>与我们联系，让我们一起创造更好的产品！</span>
        </div>
        <div class="contact-btn" @click="navTo(4)">
          <span>联系我们</span>
        </div>
      </div>
    </div>
    <!-- 尾部区域 -->
    <div class="home-footer">
      <div class="footer-header">
        <div class="left">
          <div class="logo">
            <img src="@/assets/image/footer-logo.png" alt=""/>
          </div>
        </div>
        <div class="right">
          <div class="nav-bar">
            <ul>
              <li
                v-for="(item, index) in footerNavData"
                :key="index"
                @click="navTo(index)"
              >
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="footer-footer">
        <span>Copyright © 2020 CHANGE. All Rights Reserved.</span>
      </div>
      <card-btn @click.native="openCard"></card-btn>
    </div>
    <open-menu ref="menu"></open-menu>
    <business-card ref="businessCard"></business-card>
  </div>
</template>

<script>
  import openMenu from "../../components/openMenu";
  import cardBtn from "@/components/cardBtn";
  import businessCard from "@/components/businessCard";
  import scrollReveal from "scrollreveal";

  export default {
    components: {
      openMenu,
      cardBtn,
      businessCard,
    },
    data() {
      return {
        caseData: [
          {
            id: 1,
            name: "督促系统",
            title: '执前督促溯源治理系统',
            span: ['互联网+督促', '后台系统', '小程序'],
            imgUrl: require("@/assets/image/dcxt.png"),
          },
          {
            id: 2,
            name: "速证云",
            title: '赋予强制执行视频面签工具',
            span: ['智慧政务', '小程序'],
            imgUrl: require("@/assets/image/szy.png"),
          },
          {
            id: 3,
            name: "玛莉亚U+",
            title: '医疗综合服务营销平台',
            span: ['智慧医疗', '小程序'],
            imgUrl: require("@/assets/image/mlyu+.png"),
          },
          {
            id: 4,
            name: "KAPIPO",
            title: '线上少儿教育平台',
            span: ['线上教育', '小程序'],
            imgUrl: require("@/assets/image/kapipo.png"),
          },
          {
            id: 5,
            name: "乐谷农业",
            title: '线上线下票务系统',
            span: ['互联网+教育', '小程序'],
            imgUrl: require("@/assets/image/lgny.png"),
          },
          {
            id: 6,
            name: "众诺CRM",
            title: '医疗客户管理SaaS系统',
            span: ['客户管理', '中后台'],
            imgUrl: require("@/assets/image/zncrm.png"),
          },
        ],
        resolutionData: [
          {
            id: 1,
            name: "企业转型解决方案",
            title: '以数据驱动企业现有的内外部资源。辅助软件系统实现企业智能化转型，实现全部资源的配置优化，全方面提升企业数字化经济中的竞争力。',
            imgUrl: require("@/assets/image/solution-1.png"),
          },
          {
            id: 2,
            name: "教育文娱解决方案",
            title: '提供一站式智慧教育解决方案，基于大数据、云计算能力为各种教育场景打造产品。服务于在线教育、学校、科研机构等。',
            imgUrl: require("@/assets/image/solution-2.png"),
          },
          {
            id: 3,
            name: "工业物联网解决方案",
            title: '面向企业提供软硬件一体化服务，为企业建立完整的数据平台。为智慧交通、公共平台、智能生产等行业提供端到端物联网解决方案。',
            imgUrl: require("@/assets/image/solution-3.png"),
          },
          {
            id: 4,
            name: "智慧政务解决方案",
            title: '专为政务行业建立创新型的政务服务平台，提升政务处理的时效性、安全性。全面打造“互联网+政务”的服务体系。',
            imgUrl: require("@/assets/image/solution-4.png"),
          },
        ],
        scrollReveal: scrollReveal(),
        navCardData: [
          {
            id: 1,
            name: "案例展示",
            English: "Case",
            logoUrl: require("@/assets/image/logo-ring.png"),
          },
          {
            id: 2,
            name: "解决方案",
            English: "Solution",
            logoUrl: require("@/assets/image/logo-square.png"),
          },
          {
            id: 3,
            name: "服务内容",
            English: "Service",
            logoUrl: require("@/assets/image/logo-triangle.png"),
          },
          {
            id: 4,
            name: "联系我们",
            English: "Contack",
            logoUrl: require("@/assets/image/logo-diamond.png"),
          },
          {
            id: 5,
            name: "关于我们",
            English: "About Us",
            logoUrl: require("@/assets/image/logo-a.png"),
          },
        ],
        cooperativeData: [
          {
            id: 1,
            name: "浙江大学",
            src: require("@/assets/image/zheda.png"),
          },
          {
            id: 2,
            name: "之江实验室",
            src: require("@/assets/image/zhijiang.png"),
          },
          {
            id: 3,
            name: "中国地质大学",
            src: require("@/assets/image/zgdz.png"),
          },
          {
            id: 4,
            name: "希帷科技",
            src: require("@/assets/image/xw.png"),
          },
          {
            id: 5,
            name: "玛利亚",
            src: require("@/assets/image/icon-mly.png"),
          },
        ],
        footerNavData: [
          "首页",
          "案例展示",
          "解决方案",
          "服务内容",
          "联系我们",
          "关于我们",
        ],
        showIndex: 1,
        ringShow: false,
        backgroundLogoUrl: {
          1: require("@/assets/image/ring.png"),
          2: require("@/assets/image/square.png"),
          3: require("@/assets/image/triangle.png"),
          4: require("@/assets/image/diamond.png"),
          5: require("@/assets/image/a.png"),
        },
      };
    },
    mounted() {
      this.backtop();
      this.$nextTick(() => {
        this.scrollReveal.reveal(".home-enter", {
          duration: 200,
          delay: 0,
          interval: 100,
          origin: "bottom",
          viewOffset: {
            bottom: 100,
          },
          reset: false,
          mobile: false,
          distance: "50px",
          opacity: 0,
          easing: "linear",
          scale: 1,
        });
        this.scrollReveal.reveal(".home-show", {
          duration: 200,
          delay: 0,
          interval: 100,
          origin: "bottom",
          viewOffset: {
            bottom: 100,
          },
          reset: false,
          mobile: false,
          distance: "100px",
          opacity: 0,
          easing: "linear",
          scale: 1,
        });
        this.scrollReveal.reveal(".home-title-show", {
          duration: 200,
          delay: 0,
          interval: 0,
          origin: "left",
          viewOffset: {
            bottom: 50,
          },
          reset: false,
          mobile: false,
          distance: "100px",
          opacity: 0,
          easing: "linear",
          scale: 0.9,
        });
        this.scrollReveal.reveal(".home-case-img-show", {
          duration: 200,
          delay: 0,
          interval: 100,
          origin: "left",
          viewOffset: {
            bottom: 100,
          },
          reset: false,
          mobile: false,
          distance: "0",
          opacity: 0,
          easing: "linear",
          scale: 0.5,
        });
      });
    },
    methods: {
      openMenu() {
        this.$refs.menu.open();
      },
      navTo(index) {
        if (index != 0) {
          this.$router.push({
            path: "/details",
            query: {
              menuIndex: index,
            },
          });
        } else {
          this.backtop();
        }
      },
      mouseenter(index) {
        this.ringShow = true;
        this.showIndex = index;
      },
      mouseleave() {
        this.ringShow = false;
      },
      // 回到顶部
      backtop() {
        var timer = setInterval(function () {
          let osTop =
            document.documentElement.scrollTop || document.body.scrollTop;
          let ispeed = Math.floor(-osTop / 5);
          document.documentElement.scrollTop = document.body.scrollTop =
            osTop + ispeed;
          if (osTop === 0) {
            clearInterval(timer);
          }
          this.isTop = true;
        }, 20);
      },
      openCard() {
        this.$refs.businessCard.open();
      },
      toCaseDetail(id) {
        this.$router.push({
          path: "/case",
          query: {
            id: id,
          },
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .hidden {
    opacity: 0;
  }

  .home-container {
    width: 100%;
    min-width: 1240px;
    overflow: hidden;

    .home-main {
      background: url("../../assets/image/main-background.png");
      background-size: (100%, 100%);
      position: relative;
      min-height: 900px;

      .main-header {
        max-width: 1200px;
        margin: 0 auto;
        height: 74px;
        /*padding: 0 120px;*/
        display: flex;
        justify-content: space-between;
        align-items: center;

        .logo-container {
          display: flex;
          align-items: center;

          img {
            display: block;
            width: 107px;
            height: 20px;
            margin-right: 12px;
          }

          .title {
            height: 16px;
            border-left: 1px solid #fff;
            display: flex;
            align-items: center;
            padding-left: 12px;

            span {
              font-family: PingFangSC-Medium;
              font-size: 20px;
              color: #ffffff;
              text-align: center;
            }
          }
        }

        .menu-btn-container {
          display: flex;

          .language-btn {
            width: 90px;
            height: 34px;
            border: 1px solid #ffffff;
            border-radius: 17px;
            font-family: PingFangSC-Medium;
            font-size: 14px;
            color: #ffffff;
            display: flex;
            justify-content: center;
            align-items: center;
            box-sizing: border-box;
            margin-right: 20px;
            cursor: pointer;
            user-select: none;
          }

          .menu-btn {
            box-sizing: border-box;
            cursor: pointer;
            user-select: none;

            img {
              display: block;
              width: 34px;
              height: 34px;
            }
          }
        }
      }

      .main-body {
        /*width: 100%;*/
        max-width: 1200px;
        margin: 0 auto;

        .body-content {
          width: 660px;
          margin: 166px 0 0 0;

          .main-content {
            font-family: PingFangSC-Semibold;
            font-size: 60px;
            color: #ffffff;
          }

          .sub-content {
            font-family: PingFangSC-Medium;
            font-size: 20px;
            color: #ffffff;
            margin-top: 30px;
          }
        }

        .ring-container {
          position: absolute;
          z-index: 1;
          top: 154px;
          right: -159px;

          img {
            display: block;
            width: 499px;
            height: 499px;
          }
        }

        .nav-cards-container {
          position: relative;
          z-index: 2;
          display: flex;
          justify-content: space-between;
          margin: 130px 0 60px 0;

          .nav-card-container {
            .nav-card {
              width: 220px;
              height: 300px;
              box-sizing: border-box;
              background-image: linear-gradient(180deg, #282828 0%, #000000 100%);
              border: 1px solid #002f83;
              cursor: pointer;
              user-select: none;

              .name {
                padding: 34px 0 0 34px;

                span {
                  display: block;
                  font-family: PingFangSC-Semibold;
                  font-size: 26px;
                  color: #ffffff;
                }

                span + span {
                  display: block;
                  opacity: 0.5;
                  font-family: PingFangSC-Regular;
                  font-size: 20px;
                  color: #ffffff;
                }
              }

              .logo {
                width: 100%;
                height: 201px;
                display: flex;
                justify-content: center;
                align-items: flex-end;

                img {
                  display: block;
                  height: 160px;
                }
              }
            }

            &:hover {
              .nav-card {
                background-image: linear-gradient(
                    179deg,
                    #0057ff 0%,
                    #2123ff 100%
                );
                transform: translateY(-20px) !important;
                transition: all 0.3s;
              }
            }
          }

          .active {
            background-image: linear-gradient(179deg, #0057ff 0%, #2123ff 100%);
            transform: translateY(-20px);
          }
        }
      }
    }

    .home-case {
      max-width: 1200px;
      margin: 0 auto;
      padding: 80px 0;

      .title {
        span {
          display: block;
          font-family: PingFangSC-Semibold;
          font-size: 20px;
          color: #7f7f7f;
          text-align: center;
        }

        span + span {
          display: block;
          font-family: PingFangSC-Semibold;
          font-size: 40px;
          color: #000000;
          text-align: center;
        }
      }

      .case-exhibition {
        max-width: 1200px;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 40px;

        .case-exhibition-card {
          display: flex;
          flex-direction: column;
          border: 1px solid #E5E5E5;
          margin-bottom: 30px;

          &:hover {
            transform: translateY(-10px) !important;
            box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.3);
            transition: all 0.3s;
          }

          .card-content-cell {
            background: #ffffff;
            padding: 20px;

            .card-cell-name {
              color: #000000;
              font-size: 24px;
              font-weight: bold;
            }

            .card-cell-title {
              margin-top: 8px;
              color: #000000;
              font-size: 16px;
              font-weight: normal;
            }

            .span-cell {
              margin-top: 20px;
              display: flex;
              align-items: center;

              .cell-value:first-child {
                margin-left: 0;
              }

              .cell-value {
                margin-left: 6px;
                padding: 2px 14px;
                background: #EFEEF2;
                color: #5E5E5E;
                font-size: 14px;
                border-radius: 20px;
              }
            }
          }


          img {
            display: block;
            width: 387px;
            height: 300px;

          }
        }
      }

      .all-case-btn-container {
      }

    }

    .all-case-btn {
      width: 220px;
      height: 50px;
      margin: 10px auto 0;
      border: 1px solid #000000;
      border-radius: 25px;
      font-family: PingFangSC-Medium;
      font-size: 18px;
      color: #000000;
      line-height: 26px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      user-select: none;
    }

    .home-service {
      max-width: 1200px;
      margin: 0 auto;
      width: 100%;

      .title {
        span {
          display: block;
          font-family: PingFangSC-Semibold;
          font-size: 20px;
          color: #7f7f7f;
          text-align: center;
        }

        span + span {
          display: block;
          font-family: PingFangSC-Semibold;
          font-size: 40px;
          color: #000000;
          text-align: center;
        }
      }

      .service-content-card-container {
        width: 100%;
        padding: 40px 0 30px;
        display: flex;
        justify-content: space-between;

        .service-content-card {
          max-width: 220px;
          flex: 1;
          height: 300px;
          background: #ffffff;
          padding: 30px 0 0 30px;
          box-sizing: border-box;

          .logo {
            img {
              display: block;
              width: 50px;
              height: 50px;
            }
          }

          .name {
            margin-top: 30px;
            font-family: PingFangSC-Semibold;
            font-size: 24px;
            color: #000000;
          }

          .content {
            margin-top: 14px;

            ul,
            li {
              margin: 0;
              padding: 0;
              list-style-type: none;
            }

            ul {
              li {
                margin-top: 10px;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #000000;
              }
            }
          }
        }
      }
    }

    .home-grey-box {
      width: 100%;
      background: #F3F5FB;
      padding: 80px 0;
      display: flex;
      justify-content: center;
    }

    .home-cooperative {
      max-width: 1200px;
      width: 100%;

      .title {
        span {
          display: block;
          font-family: PingFangSC-Semibold;
          font-size: 20px;
          color: #7f7f7f;
          text-align: center;
        }

        span + span {
          display: block;
          font-family: PingFangSC-Semibold;
          font-size: 40px;
          color: #000000;
          text-align: center;
        }
      }

      .cooperative-contents-container {
        margin: 40px -20px 0 0;
        display: flex;
        flex-wrap: wrap;

        .cooperative-content {
          width: 224px;
          height: 100px;
          margin-top: 40px;
          margin-right: 20px;
          // background: #eee;
          display: flex;
          justify-content: center;
          align-items: center;

          img {
            display: block;
            height: 100%;
          }
        }
      }
    }

    .home-contact {
      width: 100%;
      height: 350px;
      background: #fafafa;
      display: flex;
      align-items: center;

      .contact-content {
        width: 600px;
        margin: 0 auto;

        .main {
          font-family: PingFangSC-Semibold;
          font-size: 40px;
          color: #000000;
          text-align: center;
        }

        .sub {
          margin-top: 16px;
          font-family: PingFangSC-Regular;
          font-size: 20px;
          color: #000000;
          text-align: center;
        }

        .contact-btn {
          width: 220px;
          height: 50px;
          margin: 40px auto 0;
          display: flex;
          justify-content: center;
          align-items: center;
          background: #000000;
          border-radius: 25px;
          font-family: PingFangSC-Medium;
          font-size: 18px;
          color: #ffffff;
          line-height: 26px;
          cursor: pointer;
          user-select: none;
        }
      }
    }

    .home-resolution {
      max-width: 1200px;
      margin: 0 auto;
      padding: 80px 0;

      .title {
        span {
          display: block;
          font-family: PingFangSC-Semibold;
          font-size: 20px;
          color: #7f7f7f;
          text-align: center;
        }

        span + span {
          display: block;
          font-family: PingFangSC-Semibold;
          font-size: 40px;
          color: #000000;
          text-align: center;
        }
      }

      .resolution-exhibition {
        max-width: 1200px;
        margin: 40px auto 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .resolution-exhibition-card {
          display: flex;
          align-items: flex-end;
          justify-content: space-between;
          margin-bottom: 20px;
          width: 590px;
          height: 240px;
          box-shadow: 0 6px 40px 0 rgba(0, 0, 0, 0.04);
          padding-right: 20px;
          padding-bottom: 20px;

          .card-content-cell {
            background: #ffffff;
            padding: 50px 0 0 50px;

            .card-cell-name {
              color: #000000;
              font-size: 24px;
              font-weight: bold;
            }

            .card-cell-title {
              max-width: 300px;
              margin-top: 20px;
              color: #3D3D3D;
              font-size: 14px;
              font-weight: normal;
              line-height: 24px;
            }

            .span-cell {
              margin-top: 20px;
              display: flex;
              align-items: center;

              .cell-value:first-child {
                margin-left: 0;
              }

              .cell-value {
                margin-left: 6px;
                padding: 2px 14px;
                background: #EFEEF2;
                color: #5E5E5E;
                font-size: 14px;
                border-radius: 20px;
              }
            }
          }


          img {
            display: block;
            max-width: 150px;
            max-height: 150px;
          }
        }
      }

      .all-case-btn-container {
      }

    }

    .home-footer {
      width: 100%;
      height: 300px;
      background: #fafafa;
      position: relative;

      .footer-header {
        width: 1200px;
        border-top: 1px solid #f0f0f0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 60px 0 0 0;
        margin: 0 auto;

        .left {
          .logo {
            img {
              display: block;
              width: 160px;
            }
          }
        }

        .right {
          .nav-bar {
            ul,
            li {
              margin: 0;
              padding: 0;
              list-style-type: none;
            }

            ul {
              display: flex;

              li {
                margin-left: 40px;
                font-family: PingFangSC-Regular;
                font-size: 16px;
                color: #5e5e5e;
                cursor: pointer;
                user-select: none;

                &:active {
                  opacity: 0.6;
                }
              }
            }
          }
        }
      }

      .footer-footer {
        margin-top: 100px;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #5e5e5e;
        text-align: center;
      }

      .card-btn-container {
        position: absolute;
        right: 30px;
        bottom: 30px;
      }
    }

    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.5s;
    }

    .fade-enter,
    .fade-leave-active {
      opacity: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/home/home.vue